import React from "react";
import styles from './EvaluationProgress.module.scss';
import PropTypes from "prop-types";

const EvaluationProgress = ({
  total,
  completed
}) => {
  const percentage = completed / total * 100;
  const size = 74;
  const strokeWidth = 7;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;

  // Calculate the offset based on the percentage value
  const offset = circumference - (percentage / 100) * circumference;

  return (
    <div className={styles.circle}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        {/* Background circle */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="#F0F0FF"
          strokeWidth={strokeWidth}
          fill="none"
        />
        {/* Foreground circle (progress) */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="#171898" // Change this color for your progress color
          strokeWidth={strokeWidth}
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          transform={`rotate(-90 ${size / 2} ${size / 2})`} // Rotate to start from top
        />
      </svg>
      <span className={styles.count}>
        {completed}/{total}
      </span>
    </div>
  );
};

EvaluationProgress.propTypes = {
  completed: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
}

export default EvaluationProgress;